// Update the action type constant
export const SET_CHOOSE_ROOM = "SET_CHOOSE_ROOM";

// Action Creator
export const set_choose_room = (roomId, room, label, date, roomHistoryId) => ({
  type: SET_CHOOSE_ROOM,
  payload: { roomId, label, room, date, roomHistoryId },
});
